import { c as _c } from "react/compiler-runtime";
import { Star } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
type StarsProps = {
  id: string;
  className?: string;
  rating: number;
};
export const Stars = t0 => {
  const $ = _c(10);
  const {
    id,
    className,
    rating
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = rating_0 => {
      const stars = [];
      for (let i = 1; i <= 5; i++) {
        if (rating_0 >= i) {
          stars.push(<Star key={i} type="filled" />);
        } else {
          if (rating_0 >= i - rating_0) {
            stars.push(<Star key={i} type="dynamically-filled" fillRatio={rating_0 - Math.floor(rating_0)} fillColor="var(--color-orange-600)" emptyColor="white" gradientId={id} />);
          } else {
            stars.push(<Star key={i} />);
          }
        }
      }
      return stars;
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderStars = t1;
  let t2;
  if ($[2] !== className) {
    t2 = clsx("flex gap-2", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== rating || $[5] !== renderStars) {
    t3 = renderStars(rating);
    $[4] = rating;
    $[5] = renderStars;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};